import SelectFilterDropdown, {
  SelectFilterOption,
} from "@/components/common/dropdown/SelectFilterDropdown";

export type AdStatus = "active" | "inactive" | null;

type Props = {
  selectedType: AdStatus;
  onChange: (type: AdStatus) => void;
  className?: string;
  disabled?: boolean;
};

const options: SelectFilterOption<AdStatus>[] = [
  { key: "all", label: "All", value: null, icon: null },
  { key: "active", label: "Active", value: "active", icon: null },
  { key: "inactive", label: "Inactive", value: "inactive", icon: null },
];

const AdStatusDropdown = ({ selectedType, onChange, disabled, className }: Props) => {
  return (
    <SelectFilterDropdown
      options={options}
      selected={selectedType}
      onChange={onChange}
      className={className}
      disabled={disabled}
      label="Status"
      placeholder="All"
    />
  );
};

export default AdStatusDropdown;
